import { ref } from 'vue'
import { defineStore } from 'pinia'
import { WbffError } from '@/services/wbff/types'
import { DEFAULT_ERROR_DISPLAY_INFO } from '@/services/wbff/constants'

type GlobalConfigAbTest = {
  enabled: boolean
  userGroups: {
    [key: string]: {
      assetManagementIconBalloon: string
      assetManagementIconDescription: string
      assetManagementIconStyle: string
    }
  }
}

type GlobalConfig = {
  abTest: GlobalConfigAbTest
}

export const useCommonStore = defineStore('common', () => {
  // I think we should store actual announcements in pinia.
  //  But now, we just need the true or false status to show in the Other page.
  const hasUnreadNotices = ref<boolean>(false)
  const isCourseSelectModalVisible = ref<boolean>(false)
  const navBarIcon = ref({
    balloonText: 'NISAで運用',
    iconDescription: '追加投資',
    iconStyle: 'animation',
  })
  const isGlobalWbffErrorHalfSheetVisible = ref<boolean>(false)
  const globalWbffError = ref<WbffError>(DEFAULT_ERROR_DISPLAY_INFO)

  const userGroup = ref<string | null>(null)
  const globalConfig = ref<GlobalConfig | null>(null)

  // Legacy GA implementation
  const oprStatusGA = ref<string>('')
  const tapContentsGA = ref<string>('')

  const setHasUnreadNotices = (val: boolean) => {
    hasUnreadNotices.value = val
  }

  const setIsCourseSelectModalVisible = (val: boolean) => {
    isCourseSelectModalVisible.value = val
  }

  const setIsGlobalWbffErrorHalfSheetVisible = (val: boolean) => {
    isGlobalWbffErrorHalfSheetVisible.value = val
  }

  const setGlobalWbffError = (val: WbffError) => {
    globalWbffError.value = val
  }

  const setUserGroup = (val: string | null) => {
    userGroup.value = val
  }

  const setGlobalConfig = (val: GlobalConfig | null) => {
    globalConfig.value = val
  }

  const setTabBarIcon = () => {
    if (
      userGroup.value !== null && globalConfig.value && globalConfig.value.abTest && globalConfig.value.abTest.enabled && globalConfig.value.abTest.userGroups
    ) {
      const abTestData = globalConfig.value.abTest.userGroups[userGroup.value]
  
      if (abTestData) {
        navBarIcon.value = {
          balloonText: abTestData.assetManagementIconBalloon || 'NISAで運用',
          iconDescription: abTestData.assetManagementIconDescription || '追加投資',
          iconStyle: abTestData.assetManagementIconStyle || 'animation',
        }
      }
    }
  }

  const setOprStatusGA = (val: string) => {
    oprStatusGA.value = val
  }

  const setTapContentsGA = (val: string) => {
    tapContentsGA.value = val
  }

  return {
    hasUnreadNotices,
    isCourseSelectModalVisible,
    setHasUnreadNotices,
    setIsCourseSelectModalVisible,
    isGlobalWbffErrorHalfSheetVisible,
    globalWbffError,
    globalConfig,
    userGroup,
    setIsGlobalWbffErrorHalfSheetVisible,
    setGlobalWbffError,
    navBarIcon,
    oprStatusGA,
    tapContentsGA,
    setTabBarIcon,
    setGlobalConfig,
    setUserGroup,
    setOprStatusGA,
    setTapContentsGA,
  }
})
